import {
  ICServicesCategoryDetailTypes,
  ICServicesDetailListParams,
  ICServicesCategoryParams,
  ICServicesDetailDataTypes,
  ICServicesDetailParams,
  IndividualCustomerServiceDataTypes,
} from './types';

import axiosInstance from 'services/common/instance';

const getIndividualCustomerService = async (): Promise<IndividualCustomerServiceDataTypes[]> => {
  const response = await axiosInstance.get('khcn-services');
  return response.data.data;
};

export const getICServicesDetailListService = async (
  params: ICServicesDetailListParams,
): Promise<ICServicesDetailDataTypes[]> => {
  const response = await axiosInstance.get(`khcn-services/category/${params.slug}`);
  return response.data.data;
};

export const getICServicesCategoryDetailService = async (
  params: ICServicesCategoryParams,
): Promise<ICServicesCategoryDetailTypes> => {
  const response = await axiosInstance.get(`khcn-service-categories/${params.slug}`);
  return response.data.data;
};

export const getICServicesDetailService = async (
  params: ICServicesDetailParams,
): Promise<ICServicesDetailDataTypes> => {
  const response = await axiosInstance.get(`khcn-services/${params.slug}`);
  return response.data.data;
};

export default getIndividualCustomerService;
